/**
 * Contact reach chooser — phone assemble + chat open (THR-546).
 * Phone parts stay split in markup; assembled only in the browser.
 * Chat launcher lives in shopify-agent / shopify-chat shadow DOM.
 */
(function () {
  'use strict';

  function assemblePhone(root) {
    var link = root.querySelector('[data-tt-phone]');
    if (!link) return;

    var p = link.getAttribute('data-tt-p') || '';
    var x = link.getAttribute('data-tt-x') || '';
    var l = link.getAttribute('data-tt-l') || '';
    if (!p || !x || !l) return;

    var digits = String(p) + String(x) + String(l);
    var display = '(' + p + ') ' + x + '-' + l;
    link.setAttribute('href', 'tel:+1' + digits);
    link.textContent = display;
    link.classList.add('is-ready');

    var fallback = root.querySelector('[data-tt-call-fallback]');
    if (fallback) fallback.hidden = true;
  }

  function queryDeep(root, selectors) {
    if (!root) return null;
    for (var i = 0; i < selectors.length; i++) {
      try {
        var el = root.querySelector(selectors[i]);
        if (el) return el;
      } catch (e) {
        /* ignore invalid selectors in older browsers */
      }
    }
    return null;
  }

  function findInHost(host) {
    if (!host) return null;
    var root = host.shadowRoot;
    if (!root) return null;

    var selectors = [
      'button[aria-label="Chat"]',
      'button[aria-label="Open chat"]',
      'button[aria-controls="chat-ui"]',
      '.chat-toggle',
      '.chat-app > button',
      'button.chat-toggle',
      'button[part="activator"]',
      'button'
    ];
    return queryDeep(root, selectors);
  }

  function findChatLauncher() {
    var hosts = [
      document.querySelector('shopify-agent'),
      document.querySelector('shopify-chat'),
      document.getElementById('ShopifyChat'),
      document.querySelector('inbox-online-store-chat')
    ];

    for (var i = 0; i < hosts.length; i++) {
      var btn = findInHost(hosts[i]);
      if (btn) return btn;
    }

    /* Light-DOM fallbacks (legacy embeds) */
    return (
      document.querySelector('button[aria-label="Chat"]') ||
      document.querySelector('#ShopifyChat button') ||
      document.querySelector('#dummy-chat-button-iframe')
    );
  }

  function clickLauncher(launcher) {
    if (!launcher) return false;
    try {
      launcher.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      if (typeof launcher.click === 'function') launcher.click();
      return true;
    } catch (e) {
      try {
        launcher.click();
        return true;
      } catch (err) {
        return false;
      }
    }
  }

  function openChat(button) {
    var attempts = 0;
    var maxAttempts = 20;

    function tryOpen() {
      attempts += 1;
      var launcher = findChatLauncher();
      if (clickLauncher(launcher)) return true;

      if (attempts < maxAttempts) {
        window.setTimeout(tryOpen, 150);
        return false;
      }

      /* Last resort: focus the host so the floating control is obvious — never alert() */
      var host =
        document.querySelector('shopify-agent') ||
        document.querySelector('shopify-chat') ||
        document.getElementById('ShopifyChat');
      if (host && typeof host.focus === 'function') {
        try {
          host.focus();
        } catch (e) {
          /* ignore */
        }
      }
      if (button) {
        button.setAttribute('aria-describedby', 'tt-contact-chat-hint');
        var hint = document.getElementById('tt-contact-chat-hint');
        if (!hint) {
          hint = document.createElement('p');
          hint.id = 'tt-contact-chat-hint';
          hint.className = 'tt-contact__chat-hint';
          hint.textContent =
            button.getAttribute('data-tt-chat-fallback') ||
            'Use Chat in the lower right of the screen.';
          button.insertAdjacentElement('afterend', hint);
        }
      }
      return false;
    }

    tryOpen();
  }

  function onReady() {
    var roots = document.querySelectorAll('[data-tt-contact]');
    if (!roots.length) return;

    for (var i = 0; i < roots.length; i++) {
      assemblePhone(roots[i]);
    }

    document.addEventListener('click', function (event) {
      var chatBtn = event.target.closest('[data-tt-open-chat]');
      if (chatBtn) {
        event.preventDefault();
        openChat(chatBtn);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
